// utils/gtm.ts

import TagManager from "react-gtm-module";

interface DataLayerItem {
    event: string;
    [key: string]: any;
}

declare global {
    interface Window {
        dataLayer?: DataLayerItem[];
    }
}

interface GTMEvent {
    event?: string;
    [key: string]: any;
}

export const pushToDataLayer = (event: GTMEvent): void => {
    TagManager.dataLayer({
        dataLayer: event
    })
};